import React from "react";
import { Form, Input, Button, message } from "antd";
import { useDispatch } from "react-redux";
import { editUser } from "../../redux/userSlice"; // Update the path if necessary
import { useNavigate, useLocation } from "react-router-dom";

const EditAdminProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation(); // Retrieve passed state (user data)
  const [form] = Form.useForm();

  React.useEffect(() => {
    // Set initial form values from passed state
    if (state?.user) {
      form.setFieldsValue({
        name: state.user.name,
        phone_number: state.user.phone_number,
      });
    }
  }, [state, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      dispatch(
        editUser({
          userId: state.user.id, // Assuming `id` is the unique identifier
          userData: values,
        })
      )
        .unwrap()
        .then(() => {
          message.success("Profile updated successfully!");
          navigate(-1); // Go back to the previous page
        })
        .catch((error) => {
          message.error(error || "Failed to update profile");
        });
    } catch (errInfo) {
      console.error("Validation Failed:", errInfo);
    }
  };

  return (
    <div className="mx-8 mt-10 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-6">Edit Profile</h2>
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter your name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label="Phone Number"
          rules={[
            { required: true, message: "Please enter your phone number" },
          ]}
        >
          <Input />
        </Form.Item>
        <div className="flex gap-4">
          <Button
            type="primary"
            onClick={handleSave}
            className="bg-green-800 text-white hover:bg-green-600"
          >
            Save
          </Button>
          <Button type="default" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default EditAdminProfile;
